import { render, staticRenderFns } from "./personStatistics.vue?vue&type=template&id=97687814&scoped=true&"
import script from "./personStatistics.vue?vue&type=script&lang=ts&"
export * from "./personStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./personStatistics.vue?vue&type=style&index=0&id=97687814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97687814",
  null
  
)

export default component.exports